import { render, staticRenderFns } from "./AlterCourse.vue?vue&type=template&id=03c4267e&scoped=true&"
import script from "./AlterCourse.vue?vue&type=script&lang=js&"
export * from "./AlterCourse.vue?vue&type=script&lang=js&"
import style0 from "./AlterCourse.vue?vue&type=style&index=0&id=03c4267e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c4267e",
  null
  
)

export default component.exports